module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close()
      }
    }
  }, [_c('div', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73aadf3e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Popup.vue
// module id = 853
// module chunks = 0